import type { JSX } from 'react';

import { useUIStore } from '~/stores/uiStore';

import { ResizeHandle } from '~/components/ResizeHandle';

import { RepositoriesSidebar } from './RepositoriesSidebar';
import { RepositoryDetail } from './RepositoryDetail';

export function RepositoriesLayout(): JSX.Element {
  const width = useUIStore(s => s.repositoriesSidebarWidth);
  const setWidth = useUIStore(s => s.setRepositoriesSidebarWidth);

  return (
    <div className="flex h-full min-h-0">
      <RepositoriesSidebar width={width} />
      <ResizeHandle minWidth={420} maxWidth={800} onResize={setWidth} />
      <main className="flex-1 overflow-y-auto bg-background">
        <RepositoryDetail />
      </main>
    </div>
  );
}
